import { useEffect, useMemo } from 'react';
import { getRealDate } from '../../helpers/timezone-change-helper';
import { logOut, useIsAuthorized } from '../../features/auth/operations';

const localStorageKey = 'lmpm-logout-activity';
const localStorageTimeout = 8000;
const localStorageInterval = 3000;
export function useLogOutAfterTabClosing() {
  const isAuth = useIsAuthorized();
  const shouldLogOut = useMemo(() => {
    if (isAuth === 'loading' || isAuth === false) return false;

    const currentValue = parseInt(
      window.localStorage.getItem(localStorageKey) ?? '0',
    );
    if (
      currentValue !== 0 &&
      currentValue < getRealDate().getTime() - localStorageTimeout
    )
      return true;

    return false;
  }, [isAuth]);

  useMemo(() => {
    if (shouldLogOut) void logOut();
  }, [shouldLogOut]);

  useEffect(() => {
    const timerId = setInterval(() => {
      window.localStorage.setItem(
        localStorageKey,
        getRealDate().getTime().toString(),
      );
    }, localStorageInterval);

    return () => {
      clearInterval(timerId);
    };
  }, []);

  return shouldLogOut;
}
